import * as React from "react";
import ParagraphSup from "../../common/atom/text/paragraph_sup";
import AuthCustomerCreateForm from "./customer_create/auth_customer_create_form";
import AuthCustomerCreateSide from "./customer_create/auth_customer_create_side";
import {AuthWrapper, CreateFormFlex, CreateFormWrapper,} from "./share/auth_share_components";

interface IProps {
    handleCallCreate: (values: any) => void;
}

const AuthCustomerCreateComponent: React.FC<IProps> = (props) => {
    const {handleCallCreate} = props;

    return (
        <React.Fragment>
            <AuthWrapper>
                <CreateFormWrapper>
                    <CreateFormFlex>
                        <AuthCustomerCreateSide/>
                        <AuthCustomerCreateForm onSubmit={handleCallCreate}/>
                    </CreateFormFlex>
                    <ParagraphSup>© Libera Inc.</ParagraphSup>
                </CreateFormWrapper>
            </AuthWrapper>
        </React.Fragment>
    );
};

export default AuthCustomerCreateComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/auth/auth_customer_create.tsx